<template>
    <div class="profile-screen">
        <div class="main-screen-component">
            <div class="main-screen">
                <ConversationSidebarComponent @show-toast="showToast" :isSidebarMenuOpen="isSidebarMenuOpen"
                    :new_conversation_info="new_conversation_info" :conversation_id="conversation_id" :email="email"
                    @conversation-selected="updateConversationSelected" :is_new_conversation="is_new_conversation"
                    :conversation_title="conversation_title" :subscription="subscription"
                    :userProfilePicture="profilePicture" :userName="name" :permissions="permissions" @logout="logout"
                    :modoRedaccion="false" />

                <div class="profile-tabs-container">
                    <HeaderMenuComponent title="Mi Perfil" :permissions="permissions" :subscription="subscription"
                        :isMobile="isMobile" @toggle-sidebar="toggleSidebar" @logout="logout" @show-toast="showToast" />

                    <div class="tab-content">
                        <ProfileComponent :email="email" :permissions="permissions" :subscription="subscription" :routeHash="$route.hash" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Toast notification -->
        <div v-if="toast.show" class="toast" :class="toast.type">
            {{ toast.message }}
        </div>
    </div>
</template>

<script>
import ConversationSidebarComponent from '../components/ConversationSidebarComponent.vue';
import ProfileComponent from '../components/ProfileComponent.vue';
import HeaderMenuComponent from '../components/HeaderMenuComponent.vue';

export default {
    name: 'ProfileScreen',
    components: {
        ConversationSidebarComponent,
        ProfileComponent,
        HeaderMenuComponent

    },
    data() {
        return {
            activeTab: 'profile',
            email: '',
            name: '',
            profilePicture: null,
            subscription: null,
            permissions: [],
            conversation_id: null,
            conversation_title: null,
            is_new_conversation: true,
            new_conversation_info: {
                conversation_title: null,
                conversation_id: null
            },
            isSidebarMenuOpen: false,
            toast: {
                show: false,
                message: '',
                type: 'info',
                timeout: null
            },
            isMobile: false
        };
    },
    methods: {
        updateConversationSelected(conversationId, conversationTitle, is_new) {
            this.conversation_id = conversationId;
            this.conversation_title = conversationTitle;
            this.is_new_conversation = is_new;
            this.isSidebarMenuOpen = false;

            // Redirect to main view when a conversation is selected
            this.$router.push({
                name: 'main-view',
                query: {
                    conversation_id: conversationId,
                    conversation_title: conversationTitle,
                    is_new_conversation: is_new
                }
            });
        },
        showToast(message, type = 'info') {
            // Clear any existing timeout
            if (this.toast.timeout) {
                clearTimeout(this.toast.timeout);
            }

            // Show the toast
            this.toast.show = true;
            this.toast.message = message;
            this.toast.type = type;

            // Set a timeout to hide the toast
            this.toast.timeout = setTimeout(() => {
                this.toast.show = false;
            }, 3000);
        },
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        toggleSidebar() {
            this.isSidebarMenuOpen = !this.isSidebarMenuOpen;
        },
        goSuscribirse() {
            this.$router.push({ name: "suscribirse" });
        },
        logout() {
            // Clear user data from localStorage
            localStorage.removeItem('user_email');
            localStorage.removeItem('user_name');
            localStorage.removeItem('user_permissions');
            localStorage.removeItem('user_profile_picture');
            localStorage.removeItem('user_subscription');

            this.showToast('Sesión cerrada exitosamente', 'success');

            // Redirect to login page
            this.$router.push('/login');
        }
    },
    mounted() {
        // Get user data from localStorage
        this.email = localStorage.getItem('user_email') || '';
        this.name = localStorage.getItem('user_name') || '';
        this.profilePicture = localStorage.getItem('user_profile_picture') || null;

        // Parse JSON data from localStorage
        try {
            const subscriptionData = localStorage.getItem('user_subscription');
            if (subscriptionData) {
                this.subscription = JSON.parse(subscriptionData);
            }

            const permissionsData = localStorage.getItem('user_permissions');
            if (permissionsData) {
                this.permissions = JSON.parse(permissionsData);
            }
        } catch (error) {
            console.error('Error parsing user data from localStorage:', error);
        }

        // Redirect to login if no email is found
        if (!this.email) {
            this.$router.push('/login');
        }

        // Clear any query parameters from the URL to prevent redirection
        if (Object.keys(this.$route.query).length > 0) {
            this.$router.replace({
                name: this.$route.name,
                params: this.$route.params,
                query: {}
            });
        }

        // Check if device is mobile
        this.checkMobile();

        // Add resize event listener
        window.addEventListener('resize', this.checkMobile);
    },
    beforeUnmount() {
        // Remove resize event listener
        window.removeEventListener('resize', this.checkMobile);
    }
};
</script>

<style scoped>
.profile-screen {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    background-color: #f5f5f5;
    color: #333333;
    position: relative;
}

.main-screen-component {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100vh;
    width: 100%;
    overflow: hidden;
}

.main-screen {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    flex-grow: 1;
    position: relative;
}

.profile-tabs-container {
    flex-grow: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.header {
    width: 100%;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    background-color: rgba(230, 230, 230, 0.9);
}

.header-left {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-grow: 1;
}

.header h1 {
    font-size: 18px;
    margin: 0;
    color: #333;
    font-weight: 600;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 10px;
}

.mobile-menu-button {
    background: none;
    border: none;
    color: #333;
    font-size: 32px;
    cursor: pointer;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.subscribe-button {
    border: none;
    background-color: #a1344e;
    color: #f0f0f0;
    font-size: 14px;
    padding: 8px 24px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;
    flex-shrink: 0;
}

.subscribe-button h3 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
}

.subscribe-button:hover {
    background-color: #b71c1c;
}

.tab-content {
    flex-grow: 1;
    height: calc(100% - 60px);
    display: flex;
}

/* Toast notification */
.toast {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    padding: 12px 20px;
    border-radius: 4px;
    color: white;
    font-weight: 500;
    z-index: 1000;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    min-width: 250px;
    text-align: center;
}

.toast.info {
    background-color: #2196F3;
}

.toast.success {
    background-color: #4CAF50;
}

.toast.warning {
    background-color: #FF9800;
}

.toast.error {
    background-color: #F44336;
}

@media screen and (max-width: 768px) {
    .main-screen {
        flex-direction: column;
        flex-grow: 1;
    }

    .profile-tabs-container {
        margin-left: 0;
        width: 100%;
    }

    .header {
        padding: 12px 15px;
    }

    .header h1 {
        font-size: 16px;
    }
}
</style>
